import { useEffect, useRef } from 'react';
import * as Onboarding from './Onboarding';

function FormikErrorTracker({ step, errors, touched, values }) {
  const reportedErrorsRef = useRef(new Set());
  const reportedBlursRef = useRef(new Set());

  useEffect(() => {
    if (!touched) return;
    Object.keys(touched).forEach(field => {
      if (!touched[field]) return;
      if (!reportedBlursRef.current.has(field)) {
        reportedBlursRef.current.add(field);
        const filled = !!(values && values[field]);
        Onboarding.logFieldBlurred(step, field, filled);
      }
      if (errors && errors[field] && !reportedErrorsRef.current.has(field)) {
        reportedErrorsRef.current.add(field);
        Onboarding.logFieldError(step, field, errors[field]);
      }
    });
  }, [errors, touched, values, step]);

  return null;
}

export default FormikErrorTracker;
